import React from 'react';
import axios from "axios";
import {
  Highlight
} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

export default function TeaserProduct(props) {

  const handleAddToCartClick = (variation_id) => {
    axios({
      method: "POST",
      url: Drupal.url('cart/add?_format=json'),
      data: JSON.stringify([{
        purchased_entity_type: 'commerce_product_variation',
        purchased_entity_id: variation_id,
        quantity: 1
      }]),
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(() => {
        Drupal.cartFlyout.fetchCarts();
        Drupal.cartFlyout.flyoutOffcanvasToggle();
      })
      .catch(() => undefined);
  };

  return (
    <div className="views-row">
      <article>
        <div className="product-teaser">
          <div className="product-images-content">
            <div className="product-images">
              <div className="product-image">
                <img src={props.hit.styled_image_url} alt={props.hit.variation_title_processed} height="150"/>
              </div>
            </div>

            <div className="product-content">

              <div className="field field--name-title field--type-string field--label-hidden field__item">
                <a href={props.hit.entity_alias}>
                  <Highlight attribute="variation_title_processed" hit={props.hit}/>
                </a>
              </div>

              {props.hit.hasOwnProperty('field_isbn') ? (
                <div className="field field--name-field-isbn field--type-string field--label-hidden field__item">
                  {"ISBN: " + props.hit.field_isbn}
                </div>
              ) : null}

              <div className="field field--name-body field--type-text-with-summary field--label-hidden field__item">
                <div dangerouslySetInnerHTML={{__html: props.hit.product_body}}></div>
              </div>

              {/*@todo add {props.hit.field_availability_color}*/}
              <div className="product-availability">
                {props.hit.variation_availability_processed}
              </div>
            </div>
          </div>

          <div className="product-price-cart">
            <div className="product-price">
              <div className="field--name-price">
                € {props.hit.variation_price_processed}
              </div>
            </div>

            <div className="field field--name-variations field--type-entity-reference field--label-hidden field__items">
              <div className="field__item">
                <div data-view-mode="teaser" data-langcode="nl">
                  <div className="variations-common-elements">
                    <div className="js-form-item form-item js-form-item-quantity quantity">
                      <input readOnly type="number" name="quantity" min="1" value="1" />
                    </div>
                    <div className="form-actions form-group js-form-wrapper form-wrapper">
                      <input className="button button--primary js-form-submit form-submit" type="submit"
                             onClick={() => handleAddToCartClick(props.hit.variation_id_processed)}
                             value="Aan winkelwagen toevoegen"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </article>
    </div>
  );
}

TeaserProduct.propTypes = {
  hit: PropTypes.object.isRequired,
};
